export default __webpack_public_path__ + "static/media/cine-one.d9b4ab06.png";